import React from 'react'

import {
  IEditorialListWithImage as IContentfulEditorialListWithImage,
  IEditorialListItem as IContentfulEditorialListItem,
} from 'marketing-site/@types/generated/contentful'
import {
  IProps as IEditorialListWithImage,
  IEditorialListItem,
  EditorialListWithImage,
} from 'marketing-site/src/library/components/EditorialListWithImage'
import { transformImage } from 'marketing-site/src/transformers/elements/ContentfulImage'

export const ContentfulEditorialListWithImage = (data: IContentfulEditorialListWithImage) => {
  return <EditorialListWithImage {...transformEditorialListWithImage(data)} />
}

export function transformEditorialListWithImage({
  fields,
}: IContentfulEditorialListWithImage): IEditorialListWithImage {
  return {
    ...fields,
    image: transformImage(fields.image),
    listItems: fields.listItems.map((item) => transformEditorialListItem(item)),
  }
}

function transformEditorialListItem({ fields }: IContentfulEditorialListItem): IEditorialListItem {
  return {
    ...fields,
    icon: fields.icon && fields.icon.fields.file.url,
  }
}
